// ============================================================================
// POLISH TRANSLATIONS - CHAPTER 1: KSIĘGA RODZAJU
// ============================================================================
// Poziomy 1-13 (13 poziomów, 39 pytań)

export const chapter1Translations = {
  name: "Księga Rodzaju",
  description: "Na początku... Wiedza pozwala duchowi ożyć",
  
  spiritualWisdom: {
    principle: "Wiedza pozwala duchowi ożyć",
    scripture: "Mój lud ginie z braku wiedzy (Ozeasza 4:6)",
    application: "Każdy studiowany werset, każda odkryta prawda karmi naszą duszę i wzmacnia naszą wiarę"
  },
  
  levels: {
    1: {
      name: "Stworzenie",
      challenge: "Na początku Bóg stworzył niebo i ziemię...",
      easy: {
        question: "W ilu dniach Bóg stworzył świat?",
        options: ["5 dni", "6 dni", "7 dni", "8 dni"],
        hint: "Pomyśl o dniu odpoczynku w tygodniu",
        funFact: "💡 7. dnia Bóg odpoczął. To początek szabatu, tygodniowego dnia odpoczynku!"
      },
      medium: {
        question: "Co Bóg stworzył czwartego dnia?",
        options: ["Zwierzęta", "Człowieka", "Słońce, księżyc i gwiazdy", "Rośliny"],
        hint: "Te stworzenia oświetlają ziemię i wyznaczają czas",
        funFact: "🌟 Ciała niebieskie zostały stworzone, aby wyznaczać pory roku i święta religijne!"
      },
      hard: {
        question: "Co oznacza to, że człowiek został stworzony 'na obraz Boży'?",
        options: [
          "Identyczny wygląd fizyczny",
          "Zdolność do tworzenia i miłowania",
          "Naturalna nieśmiertelność",
          "Boska moc"
        ],
        hint: "Chodzi o duchowe i intelektualne cechy",
        funFact: "✨ Obraz Boży w nas obejmuje kreatywność, świadomość moralną i zdolność kochania!"
      }
    },
    
    2: {
      name: "Pokusa w Ogrodzie",
      challenge: "Wąż był najprzebieglejszy ze wszystkich zwierząt...",
      easy: {
        question: "Jakie zwierzę skusiło Ewę w ogrodzie?",
        options: ["Lew", "Wąż", "Orzeł", "Smok"],
        hint: "To zwierzę pełza na brzuchu",
        funFact: "🐍 Wąż reprezentuje pokusę i przebiegłość w całej Biblii!"
      },
      medium: {
        question: "Jaką kłamliwą obietnicę składa wąż Ewie?",
        options: [
          "Będziecie nieśmiertelni",
          "Będziecie bogaci",
          "Będziecie jak bogowie",
          "Będziecie szczęśliwi"
        ],
        hint: "Wąż obiecuje wzniesienie do poziomu boskiego",
        funFact: "🎭 Kłamstwo węża miesza prawdę z oszustwem - klasyczna technika pokusy!"
      },
      hard: {
        question: "Jak ten upadek wyjaśnia naszą walkę między dobrem a złem?",
        options: [
          "Zło jest silniejsze",
          "Wolna wola implikuje odpowiedzialność",
          "Bóg nas porzuca",
          "Pokusa jest niezwyciężona"
        ],
        hint: "Chodzi o naszą zdolność wyboru i przyjęcia jego konsekwencji",
        funFact: "🌳 Drzewo poznania symbolizuje wybór moralny definiujący ludzkość!"
      }
    },
    
    3: {
      name: "Kain i Abel",
      challenge: "Dwóch braci, dwie ofiary, wieczny dramat...",
      easy: {
        question: "Kto był pierwszym mordercą w historii biblijnej?",
        options: ["Abel", "Set", "Kain", "Adam"],
        hint: "Zazdrosny brat Abla",
        funFact: "⚡ Kain staje się symbolem destrukcyjnej zazdrości braterskiej!"
      },
      medium: {
        question: "Dlaczego Bóg preferował ofiarę Abla?",
        options: [
          "Większa ilość",
          "Abel był piękniejszy",
          "Ofiarowana ze szczerym sercem",
          "To było mięso"
        ],
        hint: "Bóg patrzy na serce",
        funFact: "❤️ Bóg patrzy na serce, nie tylko na pozory naszych czynów!"
      },
      hard: {
        question: "Czego uczy nas ta historia o zazdrości?",
        options: [
          "Zazdrość jest naturalna",
          "Niekontrolowana zazdrość prowadzi do zniszczenia",
          "Bóg faworyzuje niektórych",
          "Rywalizacja jest zdrowa"
        ],
        hint: "Chodzi o konsekwencje nieopanowania emocji",
        funFact: "🔥 'Grzech czai się u twoich drzwi' - Bóg ostrzega przed upadkiem!"
      }
    },

    4: {
      name: "Potop Noego",
      challenge: "Padał deszcz na ziemię przez czterdzieści dni i czterdzieści nocy...",
      easy: {
        question: "Ile dni i nocy trwał deszcz potopu?",
        options: ["30 dni", "40 dni", "50 dni", "100 dni"],
        hint: "Liczba symboliczna w Biblii",
        funFact: "☔ Liczba 40 symbolizuje próbę i przemianę w Biblii!"
      },
      medium: {
        question: "Ile czystych zwierząt Noe miał zabrać do arki?",
        options: [
          "1 parę",
          "2 pary",
          "7 par",
          "10 par"
        ],
        hint: "Więcej niż nieczystych zwierząt",
        funFact: "🦁 Czyste zwierzęta były przeznaczone na ofiary po potopie!"
      },
      hard: {
        question: "Co symbolizuje arka w naszej duchowej podróży?",
        options: [
          "Ucieczkę przed problemami",
          "Zbawienie przez wiarę i posłuszeństwo",
          "Niezbędną izolację",
          "Wyższość wierzących"
        ],
        hint: "Chodzi o zbawienie oferowane tym, którzy wierzą",
        funFact: "🚢 Arka zapowiada zbawienie: jedna droga ucieczki przed sądem!"
      }
    },

    5: {
      name: "Wieża Babel",
      challenge: "Zbudujmy sobie wieżę, której wierzchołek sięgnie nieba...",
      easy: {
        question: "Co Bóg pomieszał w Babel?",
        options: ["Plany", "Języki", "Narzędzia", "Myśli"],
        hint: "To, co pozwala się komunikować",
        funFact: "🗣️ Babel jest mitycznym źródłem światowej różnorodności językowej!"
      },
      medium: {
        question: "Dlaczego ludzie chcieli zbudować tę wieżę?",
        options: [
          "Aby się chronić",
          "Aby żyć razem",
          "Aby uczynić sobie imię i dosięgnąć nieba",
          "Aby uczcić Boga"
        ],
        hint: "Chodzi o pychę i chęć dorównania Bogu",
        funFact: "🏗️ Pycha chęci dorównania Bogu zawsze prowadzi do zamieszania!"
      },
      hard: {
        question: "Jak pycha Babel przejawia się dzisiaj?",
        options: [
          "Tylko w technologii",
          "W ludzkiej woli absolutnej autonomii bez Boga",
          "W drapaczach chmur",
          "W różnych językach"
        ],
        hint: "Chodzi o chęć obejścia się bez Boga",
        funFact: "💭 Babel przypomina nam, że jedność bez Boga staje się destrukcyjną pychą!"
      }
    },

    6: {
      name: "Powołanie Abrahama",
      challenge: "Wyjdź z twojej ziemi, twojej ojczyzny i domu twojego ojca...",
      easy: {
        question: "Ile lat miał Abraham, kiedy opuścił swoją ziemię?",
        options: ["50 lat", "65 lat", "75 lat", "100 lat"],
        hint: "Bardzo zaawansowany wiek, aby zacząć od nowa",
        funFact: "🚶 W wieku 75 lat Abraham zaczyna nowe życie - nigdy nie jest za późno!"
      },
      medium: {
        question: "Jaką potrójną obietnicę Bóg składa Abrahamowi?",
        options: [
          "Bogactwo, władza, mądrość",
          "Ziemia, potomstwo, uniwersalne błogosławieństwo",
          "Długie życie, pokój, dobrobyt",
          "Wiara, nadzieja, miłość"
        ],
        hint: "Obietnica dotycząca całej ludzkości",
        funFact: "🌟 Obietnica dla Abrahama dotyczy całej ludzkości, nie tylko jego!"
      },
      hard: {
        question: "Czego uczy nas 'skok wiary' Abrahama?",
        options: [
          "Ślepa wiara jest niebezpieczna",
          "Podążanie za Bogiem wymaga porzucenia naszych zabezpieczeń",
          "Bóg faworyzuje pewne narody",
          "Wiara gwarantuje sukces"
        ],
        hint: "Chodzi o zaufanie porzucając nasze punkty odniesienia",
        funFact: "✨ Abraham nazywany jest 'ojcem wiary', bo wierzył nie widząc!"
      }
    },

    7: {
      name: "Ofiara Izaaka",
      challenge: "Weź twojego syna, twojego jedynego, którego kochasz...",
      easy: {
        question: "Na której górze Abraham miał złożyć Izaaka w ofierze?",
        options: ["Synaj", "Moria", "Karmel", "Syjon"],
        hint: "Ta góra stanie się świętym miejscem",
        funFact: "🏔️ Góra Moria stanie się miejscem Świątyni Jerozolimskiej!"
      },
      medium: {
        question: "Co Bóg dostarczył zamiast Izaaka?",
        options: [
          "Baranka",
          "Barana zawieszonego rogami",
          "Kozę",
          "Byka"
        ],
        hint: "Dorosłe zwierzę męskie z rogami",
        funFact: "🐏 Zastąpiony baran zapowiada ostateczną ofiarę zastępczą!"
      },
      hard: {
        question: "Jak ta próba ilustruje absolutną wiarę?",
        options: [
          "Bóg testuje okrutnie",
          "Wiara przewyższa nawet ojcowską miłość",
          "Ofiary ludzkie podobają się Bogu",
          "Abraham nie kochał naprawdę Izaaka"
        ],
        hint: "Chodzi o zaufanie nawet gdy się nie rozumie",
        funFact: "💝 Bóg zawsze zapewnia wyjście, gdy mu ufamy!"
      }
    },

    8: {
      name: "Jakub i Ezaw",
      challenge: "Młodszy będzie służył starszemu...",
      easy: {
        question: "Za co Ezaw sprzedał swoje pierworodztwo?",
        options: ["Za złoto", "Za miskę soczewicy", "Za ubrania", "Za wino"],
        hint: "Danie zaspokajające głód",
        funFact: "🍲 Chwila głodu kosztowała Ezawa wieczne błogosławieństwo!"
      },
      medium: {
        question: "Jak Jakub oszukał swojego ojca Izaaka?",
        options: [
          "Zmieniając głos",
          "Przebierając się",
          "Okrywając się skórą koźlą",
          "Kłamiąc o swoim imieniu"
        ],
        hint: "Aby przypominać włochatego brata",
        funFact: "🎭 Izaak, ślepy, rozpoznał zapach i dotyk, ale nie oszustwo!"
      },
      hard: {
        question: "Co ujawnia ta historia o naszych wyborach?",
        options: [
          "Oszustwo jest czasem konieczne",
          "Natychmiastowe pragnienia mogą kosztować nasze przeznaczenie",
          "Bóg akceptuje przebiegłość",
          "Młodszy jest zawsze faworyzowany"
        ],
        hint: "Chodzi o konsekwencje naszych impulsywnych decyzji",
        funFact: "⚖️ Nasze impulsywne wybory mogą mieć wieczne konsekwencje!"
      }
    },

    9: {
      name: "Sen Jakuba",
      challenge: "Zobaczył drabinę ustawioną na ziemi, której szczyt dotykał nieba...",
      easy: {
        question: "Co zobaczył Jakub w swoim śnie?",
        options: [
          "Olbrzymie drzewo",
          "Drabinę do nieba z aniołami",
          "Świątynię",
          "Gwiazdy"
        ],
        hint: "Środek komunikacji między niebem a ziemią",
        funFact: "👼 Drabina Jakuba symbolizuje połączenie między Niebem a Ziemią!"
      },
      medium: {
        question: "Co Jakub zrobił z kamieniem, który służył mu za poduszkę?",
        options: [
          "Złamał go",
          "Zakopał go",
          "Ustawił go i namaścił olejem",
          "Zabrał go ze sobą"
        ],
        hint: "Uczynił z niego święty pomnik",
        funFact: "🪨 Ten kamień staje się 'Betel' - domem Boga!"
      },
      hard: {
        question: "Jak ta wizja łączy niebo i ziemię w naszym życiu?",
        options: [
          "Tylko przez sny",
          "Przez modlitwę ustanawiającą most z Boskością",
          "Przez anioły stróżów",
          "Przez święte miejsca"
        ],
        hint: "Chodzi o naszą komunikację z Bogiem",
        funFact: "🌉 Modlitwa jest naszą osobistą drabiną do Nieba!"
      }
    },

    10: {
      name: "Józef Sprzedany przez Braci",
      challenge: "Oto nadchodzi marzyciel...",
      easy: {
        question: "Ilu braci miał Józef?",
        options: ["7 braci", "10 braci", "11 braci", "12 braci"],
        hint: "O jednego mniej niż liczba pokoleń Izraela",
        funFact: "👨‍👨‍👦‍👦 12 synów Jakuba stanie się 12 pokoleniami Izraela!"
      },
      medium: {
        question: "Za ile srebrników sprzedano Józefa?",
        options: [
          "10 srebrników",
          "20 srebrników",
          "30 srebrników",
          "50 srebrników"
        ],
        hint: "Cena niewolnika",
        funFact: "💰 20 srebrników, cena niewolnika w tamtych czasach!"
      },
      hard: {
        question: "Jak zazdrość staje się narzędziem boskiego planu?",
        options: [
          "Bóg aprobuje zazdrość",
          "Zło zostaje przekształcone w dobro przez Boga",
          "Zazdrość jest konieczna",
          "Bracia mieli rację"
        ],
        hint: "Chodzi o Boską opatrzność transformującą zło",
        funFact: "🎨 Bóg przekształca nawet nasze najgorsze czyny w arcydzieła łaski!"
      }
    },

    11: {
      name: "Józef w Więzieniu",
      challenge: "Pan był z Józefem i okazał mu swoje miłosierdzie...",
      easy: {
        question: "Jaki szczególny dar miał Józef?",
        options: [
          "Prorokowanie",
          "Interpretowanie snów",
          "Uzdrawianie chorych",
          "Rozmawianie ze zwierzętami"
        ],
        hint: "Zdolność związana z marzeniami sennymi",
        funFact: "💭 Sny były uważane za boskie przesłania w starożytności!"
      },
      medium: {
        question: "Jaccy słudzy faraona byli w więzieniu z Józefem?",
        options: [
          "Wezyr i skryba",
          "Podczaszy i piekarz",
          "Lekarz i strażnik",
          "Kucharz i ogrodnik"
        ],
        hint: "Ten, który podawał wino i ten, który podawał chleb",
        funFact: "🍷 Podczaszy próbował wina króla, aby uniknąć trucizny!"
      },
      hard: {
        question: "Czego uczy nas Józef o wierności w przeciwnościach?",
        options: [
          "Niesprawiedliwość jest akceptowalna",
          "Wierność Bogu przewyższa okoliczności",
          "Więzienie zmienia ludzi",
          "Trzeba się mścić"
        ],
        hint: "Chodzi o pozostanie wiernym nawet w próbach",
        funFact: "⭐ Nawet w więzieniu Józef pozostał prawy i Bóg go wywyższył!"
      }
    },

    12: {
      name: "Sny Faraona",
      challenge: "Siedem krów tłustych... siedem krów chudych...",
      easy: {
        question: "Ile chudych krów pożarło tłuste krowy?",
        options: ["5", "6", "7", "8"],
        hint: "Liczba doskonała",
        funFact: "🐄 Liczba 7 symbolizuje doskonałość i pełnię w Biblii!"
      },
      medium: {
        question: "Co oznaczało 7 lat w śnie?",
        options: [
          "7 lat wojny potem pokoju",
          "7 lat obfitości potem 7 lat głodu",
          "7 lat choroby potem zdrowia",
          "7 lat deszczu potem suszy"
        ],
        hint: "Cykl obfitości i niedostatku",
        funFact: "🌾 Józef uratował Egipt i swoją rodzinę dzięki tej interpretacji!"
      },
      hard: {
        question: "Jak boska mądrość przekształca kryzysy?",
        options: [
          "Unikając wszelkich kryzysów",
          "Dając przezorność do przygotowania się",
          "Karząc złych",
          "Wzbogacając wierzących"
        ],
        hint: "Chodzi o przygotowanie i antycypację",
        funFact: "💡 Boska mądrość przekształca kryzysy w szanse zbawienia!"
      }
    },

    13: {
      name: "Pojednanie Braci",
      challenge: "Jestem Józef, wasz brat, którego sprzedaliście...",
      easy: {
        question: "Co Józef włożył do worka Beniamina?",
        options: [
          "Złoto",
          "Swój pierścień",
          "Swój srebrny kielich",
          "List"
        ],
        hint: "Osobisty cenny przedmiot",
        funFact: "🏆 Kielich służył też do 'czytania' przyszłości w wodzie!"
      },
      medium: {
        question: "Jaką słynną frazę Józef wypowiedział o złu przekształconym?",
        options: [
          "Przebaczam wam",
          "Myśleliście uczynić mi zło, Bóg zamienił to w dobro",
          "Zapomnijmy o przeszłości",
          "Zemsta należy do Boga"
        ],
        hint: "Fraza o boskiej opatrzności",
        funFact: "✨ Ta fraza podsumowuje całą boską opatrzność w naszym życiu!"
      },
      hard: {
        question: "Jak przebaczenie przerywa cykle zemsty?",
        options: [
          "Zapominając o złu",
          "Uwalniając sprawcę i ofiarę dla nowego początku",
          "Najpierw karząc",
          "Zachowując dystans"
        ],
        hint: "Chodzi o wzajemne uwolnienie",
        funFact: "🕊️ Przebaczenie Józefa zapowiada uniwersalne boskie przebaczenie!"
      }
    }
  }
};

export default chapter1Translations;